/* eslint-disable camelcase */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Button, Card, CardBody, CardFooter, CardHeader, Col, Form, FormGroup, Input,
  Label, Row,
} from 'reactstrap';
import PinModal from '../../components/pin';

const nullableNumber = value => (value === '' || value === null ? null : Number(value));
const nullableString = value => (value === '' || value === null ? null : value);
const inputValue = value => (value === null || value === undefined ? '' : value);

class WebCityForm extends React.Component {
  constructor(props) {
    super(props);
    const { city } = props;
    this.state = {
      city_id: inputValue(city.city_id),
      web_country_id: inputValue(city.web_country_id),
      name_en: inputValue(city.name_en),
      name_fr: inputValue(city.name_fr),
      name_ar: inputValue(city.name_ar),
      latitude: inputValue(city.latitude),
      longitude: inputValue(city.longitude),
      timezone: inputValue(city.timezone),
      priority: city.priority === undefined ? 0 : city.priority,
      enabled: city.enabled === undefined ? true : Boolean(Number(city.enabled)),
      submitted: false,
    };
    this.failedSubmit = this.failedSubmit.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    const { name, type } = e.target;
    const value = type === 'checkbox' ? e.target.checked : e.target.value;
    this.setState({ [name]: value });
  }

  handleSubmit() {
    const { onSubmit } = this.props;
    const {
      city_id, web_country_id, name_en, name_fr, name_ar, latitude, longitude,
      timezone, priority, enabled,
    } = this.state;
    const body = {
      city_id: nullableNumber(city_id),
      web_country_id: Number(web_country_id),
      name_en,
      name_fr,
      name_ar,
      latitude: nullableNumber(latitude),
      longitude: nullableNumber(longitude),
      timezone: nullableString(timezone),
      priority: Number(priority),
      enabled: enabled ? 1 : 0,
    };
    onSubmit({ body: JSON.stringify(body) }).then((result) => {
      if (!result.ok) this.setState({ submitted: false });
    });
  }

  failedSubmit() {
    this.setState({ submitted: false });
  }

  render() {
    const {
      city_id, web_country_id, name_en, name_fr, name_ar, latitude, longitude,
      timezone, priority, enabled, submitted,
    } = this.state;
    const {
      cancel, cities, submitLabel, title, webCountries,
    } = this.props;
    return (
      <div className="animated fadeIn">
        {submitted && (
          <PinModal successSubmit={this.handleSubmit} failedSubmit={this.failedSubmit} />
        )}
        <Row>
          <Col lg={8}>
            <Card>
              <Form onSubmit={(e) => { e.preventDefault(); this.setState({ submitted: true }); }}>
                <CardHeader><strong>{title}</strong></CardHeader>
                <CardBody>
                  <FormGroup>
                    <Label for="web_country_id">Web Country</Label>
                    <Input type="select" name="web_country_id" id="web_country_id" value={web_country_id} onChange={e => this.handleChange(e)} required>
                      <Fragment>
                        <option value="" />
                        {webCountries.map(item => (
                          <option key={item.id} value={item.id}>
                            {item.name_en || item.name_fr || item.name_ar || item.ISOcountryCode || item.id}
                          </option>
                        ))}
                      </Fragment>
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label for="city_id">Original City</Label>
                    <Input type="select" name="city_id" id="city_id" value={city_id} onChange={e => this.handleChange(e)}>
                      <Fragment>
                        <option value="">None</option>
                        {cities.map(item => <option key={item.id} value={item.id}>{item.name}</option>)}
                      </Fragment>
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label for="name_en">English Name</Label>
                    <Input type="text" name="name_en" id="name_en" value={name_en} onChange={e => this.handleChange(e)} />
                  </FormGroup>
                  <FormGroup>
                    <Label for="name_fr">French Name</Label>
                    <Input type="text" name="name_fr" id="name_fr" value={name_fr} onChange={e => this.handleChange(e)} />
                  </FormGroup>
                  <FormGroup>
                    <Label for="name_ar">Arabic Name</Label>
                    <Input type="text" name="name_ar" id="name_ar" value={name_ar} onChange={e => this.handleChange(e)} />
                  </FormGroup>
                  <FormGroup>
                    <Label for="latitude">Latitude</Label>
                    <Input type="number" step="any" name="latitude" id="latitude" value={latitude} onChange={e => this.handleChange(e)} />
                  </FormGroup>
                  <FormGroup>
                    <Label for="longitude">Longitude</Label>
                    <Input type="number" step="any" name="longitude" id="longitude" value={longitude} onChange={e => this.handleChange(e)} />
                  </FormGroup>
                  <FormGroup>
                    <Label for="timezone">IANA Timezone</Label>
                    <Input
                      type="text"
                      name="timezone"
                      id="timezone"
                      value={timezone}
                      placeholder="Asia/Kabul or UTC"
                      pattern="(?:UTC|[A-Za-z_+-]+(?:/[A-Za-z0-9_.+-]+)+)"
                      title="Enter an IANA timezone such as Asia/Kabul, or UTC"
                      onChange={e => this.handleChange(e)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="priority">Priority</Label>
                    <Input type="number" name="priority" id="priority" value={priority} onChange={e => this.handleChange(e)} required />
                  </FormGroup>
                  <FormGroup check>
                    <Label check>
                      <Input type="checkbox" name="enabled" checked={enabled} onChange={e => this.handleChange(e)} />
                      {' Enabled'}
                    </Label>
                  </FormGroup>
                </CardBody>
                <CardFooter>
                  <Button type="submit" size="sm" color="success">{submitLabel}</Button>
                  {' '}
                  <Button type="button" onClick={cancel} size="sm" color="danger">Cancel</Button>
                </CardFooter>
              </Form>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

WebCityForm.propTypes = {
  cancel: PropTypes.func.isRequired,
  cities: PropTypes.arrayOf(PropTypes.object),
  city: PropTypes.shape({}),
  onSubmit: PropTypes.func.isRequired,
  submitLabel: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  webCountries: PropTypes.arrayOf(PropTypes.object),
};

WebCityForm.defaultProps = { cities: [], city: {}, webCountries: [] };

export default WebCityForm;
